// A palm: one continuous tapering trunk (no segment gaps) crowned by long
// drooping fronds radiating from a hub, plus a couple of coconuts. Ported 1:1
// from age-of-mcp's classic tree-palm.ts, restoring its radial frond loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const crownY = 1.9;
  const parts: Part[] = [
    // single trunk, base at y=0 -> top at the crown, gently tapering.
    { geometry: new THREE.CylinderGeometry(0.07, 0.12, crownY, 7),
      color: "#9c7b46", position: [0, crownY / 2, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#6b5128",
      position: [0, crownY, 0] },                       // crown hub
  ];
  // 8 fronds radiating from the hub, drooping down and out.
  const N = 8;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.BoxGeometry(0.95, 0.04, 0.2),
      color: i % 2 ? "#3f9a4a" : "#4caf57",
      position: [Math.cos(a) * 0.4, crownY - 0.08, Math.sin(a) * 0.4],
      rotation: [0, -a, -0.38],   // tilt the outer end down
    });
  }
  // coconuts under the crown
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#5a4327",
    position: [0.07, crownY - 0.12, 0.05] });
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#6b5230",
    position: [-0.08, crownY - 0.14, -0.04] });
  return parts;
}

export const treePalm = defineModel({
  id: "tree-palm",
  batchId: "standard",
  name: "Tree palm",
  tags: ["scenery","tree","palm","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree palm.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => partsFor(),
  animations: [],
});
